var map = {
	"./animation/bear.webp": 7270,
	"./animation/beast1.webp": 2447,
	"./animation/beast2.webp": 8520,
	"./animation/beast3.webp": 350,
	"./animation/bison.webp": 7299,
	"./animation/bull.webp": 5637,
	"./animation/cat.webp": 4882,
	"./animation/chicken.webp": 6802,
	"./animation/chicken_pool.webp": 6644,
	"./animation/coala.webp": 6279,
	"./animation/dog1.webp": 8310,
	"./animation/dog2.webp": 7189,
	"./animation/eagle.webp": 686,
	"./animation/et.webp": 1567,
	"./animation/fairy1.png": 4381,
	"./animation/fairy1.webp": 1963,
	"./animation/fairy2.webp": 3187,
	"./animation/fairy3.webp": 2499,
	"./animation/fairy4.webp": 2828,
	"./animation/fish1.webp": 2324,
	"./animation/fish2.webp": 4906,
	"./animation/fox.webp": 4549,
	"./animation/frog-ball.webp": 4840,
	"./animation/frog_coctail.webp": 7986,
	"./animation/gif-maker-6.webp": 7247,
	"./animation/girl_crown.webp": 1253,
	"./animation/girl_in_white.webp": 9309,
	"./animation/girl_pink_dress.webp": 309,
	"./animation/hearts.webp": 9011,
	"./animation/japanese_blue.webp": 7905,
	"./animation/japanese_green.webp": 8584,
	"./animation/japanese_pink.gif": 9339,
	"./animation/japanese_yellow.webp": 9941,
	"./animation/japanese_yellow1.webp": 182,
	"./animation/magician.webp": 140,
	"./animation/musician_cat.webp": 3773,
	"./animation/musician_dog.webp": 8144,
	"./animation/musician_donkey.webp": 3972,
	"./animation/musician_rooster.webp": 4790,
	"./animation/pig.webp": 2750,
	"./animation/polar_bear.webp": 2928,
	"./animation/polar_bear_orig.webp": 3092,
	"./animation/puma.webp": 6722,
	"./animation/snow_leopard.webp": 6952,
	"./animation/summer_friends1.webp": 4049,
	"./animation/summer_friends2.webp": 7938,
	"./animation/swords.webp": 331,
	"./animation/wolf.webp": 4157,
	"./animation/wolf_realistic.webp": 6688,
	"./fonts/Manrope-Bold.woff": 266,
	"./fonts/Manrope-Bold.woff2": 4880,
	"./fonts/Manrope-Medium.woff": 4990,
	"./fonts/Manrope-Medium.woff2": 2718,
	"./fonts/Manrope-SemiBold.woff": 6532,
	"./fonts/Manrope-SemiBold.woff2": 6015,
	"./images/alice_characters.jpg": 9547,
	"./images/alice_location1.jpg": 6406,
	"./images/alice_location2.jpg": 832,
	"./images/alice_location3.jpg": 8447,
	"./images/alice_location4.jpg": 3334,
	"./images/alice_location5.jpg": 728,
	"./images/alice_location6.jpg": 1220,
	"./images/alice_location7.jpg": 6217,
	"./images/alice_location8.jpg": 9893,
	"./images/char10_slots.jpg": 6773,
	"./images/char11_slots.jpg": 6074,
	"./images/char12_slots.jpg": 6671,
	"./images/char15_slots.jpg": 1926,
	"./images/char16_slots.jpg": 1162,
	"./images/char1_royal.jpg": 4872,
	"./images/char1_slots.jpg": 6250,
	"./images/char2_royal.jpg": 8434,
	"./images/char2_slots.jpg": 3480,
	"./images/char3_royal_slots.jpg": 1819,
	"./images/char3_slots.jpg": 7537,
	"./images/char4_royal_slots.jpg": 595,
	"./images/char4_slots.jpg": 9284,
	"./images/char5_slots.jpg": 8188,
	"./images/char6_slots.jpg": 6930,
	"./images/char7_slots.jpg": 8063,
	"./images/char8_slots.jpg": 7658,
	"./images/char_13_slots.jpg": 389,
	"./images/char_14_slots.jpg": 1247,
	"./images/corgi_big_1.png": 4107,
	"./images/event_halloween1.jpg": 4351,
	"./images/event_ny.jpg": 3627,
	"./images/event_ny2.jpg": 9006,
	"./images/event_pick.jpg": 4507,
	"./images/icon_777_2021.png": 2239,
	"./images/icon_777_2022.png": 9578,
	"./images/icon_Chameleon_sunset.png": 1820,
	"./images/icon_buffalo.png": 4293,
	"./images/icon_cash.png": 9954,
	"./images/icon_cash_closechest.png": 142,
	"./images/icon_chameleon2.png": 3351,
	"./images/icon_cherry.png": 8711,
	"./images/icon_chesh_3inrow.png": 1254,
	"./images/icon_chesh_hat.png": 8765,
	"./images/icon_chesh_sunglasse.png": 5817,
	"./images/icon_cheshirecat.png": 7933,
	"./images/icon_chicagogirl.png": 7378,
	"./images/icon_chicken.png": 1961,
	"./images/icon_closechest_newcoins.png": 8596,
	"./images/icon_clover.png": 4230,
	"./images/icon_coinbg23_512x512.png": 1759,
	"./images/icon_cryptocoin_dog.png": 6511,
	"./images/icon_doggy_pinapple.png": 5446,
	"./images/icon_doggymatch.png": 1906,
	"./images/icon_dynamite.png": 8996,
	"./images/icon_fish.png": 9431,
	"./images/icon_fox.png": 3262,
	"./images/icon_kitty3.png": 665,
	"./images/icon_kitty_crown.png": 3233,
	"./images/icon_leprhat.png": 2991,
	"./images/icon_octopusfield.png": 97,
	"./images/icon_pearl.png": 1491,
	"./images/icon_pepper_2021.png": 1121,
	"./images/icon_pepper_2022.png": 1516,
	"./images/icon_pot.png": 6166,
	"./images/icon_pot_2022.png": 6537,
	"./images/items1_royal.jpg": 3011,
	"./images/items1_summer.jpg": 3717,
	"./images/items2_royal.jpg": 1520,
	"./images/items2_slots.jpg": 8902,
	"./images/items2_summer.jpg": 3514,
	"./images/items3_slots.jpg": 9646,
	"./images/items3_summer.jpg": 1575,
	"./images/items4_slots.jpg": 9477,
	"./images/items4_summer.jpg": 2438,
	"./images/items5_slots.jpg": 7904,
	"./images/items6_slots.jpg": 3840,
	"./images/items7_slots.jpg": 3484,
	"./images/items_alice.jpg": 6691,
	"./images/items_slots.jpg": 8285,
	"./images/logo.png": 4427,
	"./images/mob_alice_chars1.jpg": 6268,
	"./images/mob_alice_chars2.jpg": 5569,
	"./images/mob_alice_chars3.jpg": 4867,
	"./images/mob_animals_slots1.jpg": 4456,
	"./images/mob_animals_slots2.jpg": 652,
	"./images/mob_animals_slots3.jpg": 1078,
	"./images/mob_summer_friend1.jpg": 7258,
	"./images/mob_summer_friend12.jpg": 3955,
	"./images/mob_summer_friend3.jpg": 2739,
	"./images/panda2.png": 9504,
	"./images/royal_location1.jpg": 5271,
	"./images/royal_location2.jpg": 3673,
	"./images/royal_location3.jpg": 4277,
	"./images/royal_location4.jpg": 8381,
	"./images/royal_location5.jpg": 2227,
	"./images/royal_location6.jpg": 1686,
	"./images/slot_aztec.jpg": 1486,
	"./images/slot_buffalo.jpg": 8080,
	"./images/slot_cabaret.jpg": 9080,
	"./images/slot_characters1.jpg": 5401,
	"./images/slot_classic.jpg": 2133,
	"./images/slot_doctor.jpg": 3462,
	"./images/slot_fireman.jpg": 9471,
	"./images/slot_japan.jpg": 7491,
	"./images/slot_japan2.jpg": 5348,
	"./images/slot_kong.jpg": 1061,
	"./images/slot_location1.jpg": 7842,
	"./images/slot_location2.jpg": 4501,
	"./images/slot_location3.jpg": 375,
	"./images/slot_location4.jpg": 7758,
	"./images/slot_location5.jpg": 9439,
	"./images/slot_location6.jpg": 4954,
	"./images/slot_location7.jpg": 1079,
	"./images/slot_ninja.jpg": 5410,
	"./images/slot_oz.jpg": 2115,
	"./images/slot_pinup.jpg": 2129,
	"./images/slot_poker.jpg": 2430,
	"./images/slot_robbery.jpg": 5916,
	"./images/slot_sherlock.jpg": 9799,
	"./images/slot_sparta.jpg": 7251,
	"./images/slot_tennis.jpg": 9883,
	"./images/slot_troy1.jpg": 106,
	"./images/slot_troy2.jpg": 6383,
	"./images/slot_usa.jpg": 4804,
	"./images/summer_characters.jpg": 2740,
	"./images/summer_locations1.jpg": 7092,
	"./images/summer_locations2.jpg": 9175,
	"./images/summer_locations3.jpg": 4758,
	"./images/summer_locations4.jpg": 4025,
	"./images/summer_locations5.jpg": 6878,
	"./images/ui_ns_1.jpg": 9177,
	"./images/ui_ns_1.png": 6385,
	"./images/ui_ns_2.jpg": 2250,
	"./images/ui_ns_2.png": 3737,
	"./images/ui_ns_3.jpg": 4565,
	"./images/ui_ns_3.png": 8682,
	"./images/ui_ns_4.jpg": 3322,
	"./images/ui_ns_4.png": 2670,
	"./images/ui_ns_5.jpg": 1761,
	"./images/ui_ns_5.png": 9389,
	"./images/ui_rs_1.jpg": 9531,
	"./images/ui_rs_1.png": 6764,
	"./images/ui_rs_2.jpg": 3451,
	"./images/ui_rs_2.png": 1652,
	"./images/ui_rs_3.jpg": 48,
	"./images/ui_rs_3.png": 1356,
	"./images/ui_sf_1.jpg": 5748,
	"./images/ui_sf_1.png": 3874,
	"./images/ui_sf_2.jpg": 6355,
	"./images/ui_sf_2.png": 5991,
	"./images/ui_sf_3.jpg": 5921,
	"./images/ui_sf_3.png": 5987,
	"./images/ui_sf_4.jpg": 527,
	"./images/ui_sf_4.png": 5090,
	"./images/ui_sf_5.jpg": 4091,
	"./images/ui_sf_5.png": 5126,
	"./images/ui_sf_6.jpg": 4327,
	"./images/ui_sf_6.png": 4369,
	"./video/0059_unicorn.mp4": 9680,
	"./video/0062__38mb.mp4": 9094,
	"./video/0067_16.9_30sec.mp4": 1880,
	"./video/0068_30sec.mp4": 8541,
	"./video/0081_1_RSlots_JapanScreen.mp4": 7737,
	"./video/080_1_Mexico_screen.mp4": 7001,
	"./video/083_1_3MainScreens.mp4": 764,
	"./video/bazooka.jpg": 3695,
	"./video/japan.jpg": 5574,
	"./video/mexico.jpg": 493,
	"./video/noob.jpg": 6780,
	"./video/noob2.jpg": 4620,
	"./video/party.jpg": 5943,
	"./video/royal.jpg": 8006,
	"./video/slots_party.mp4": 9206,
	"./video/team.jpg": 9673,
	"./video/unicorn.jpg": 7478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;